import { cn } from "@ui/lib";

/**
 * 比例预览小方块：等比缩放到 size×size 的方框内，长边贴边。
 * 固定宽度的话竖版只会越变越高，9:16 和 1:1 一样宽反而看不出区别，行高也会被撑乱。
 */
const DEFAULT_SIZE = 26;

/** 跟随原图的选项没有固定比例，用虚线方块表示，避免和 1:1 长得一样 */
const FOLLOW_SOURCE_VALUES = new Set(["auto", "original"]);

const getDimensions = (value: string, box: number) => {
	const [w, h] = value.split(":").map(Number);
	if (!w || !h) {
		return { width: box, height: box };
	}
	return {
		width: w >= h ? box : Math.round((box * w) / h),
		height: h >= w ? box : Math.round((box * h) / w),
	};
};

export function AspectRatioSwatch({
	value,
	className,
	size = DEFAULT_SIZE,
}: {
	/** 形如 "16:9"，或 "auto" / "original" 表示跟随原图 */
	value: string;
	/** 方块自身的配色，由调用方决定（各处选中态样式不同） */
	className?: string;
	/** 外框边长（px），长边贴边 */
	size?: number;
}) {
	const { width, height } = getDimensions(value, size);

	return (
		<div
			className="flex items-center justify-center"
			style={{ height: `${size}px` }}
		>
			<div
				className={cn(
					"rounded-[2px] transition-colors",
					className,
					FOLLOW_SOURCE_VALUES.has(value) &&
						"border border-current border-dashed bg-transparent",
				)}
				style={{ width: `${width}px`, height: `${height}px` }}
			/>
		</div>
	);
}
